import { render, staticRenderFns } from "./JSelectTeacherUserId.vue?vue&type=template&id=050b4e2a&scoped=true"
import script from "./JSelectTeacherUserId.vue?vue&type=script&lang=js"
export * from "./JSelectTeacherUserId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050b4e2a",
  null
  
)

export default component.exports